import { AxiosError } from 'axios';
import { toast } from 'sonner';

export interface ApiError {
  message: string;
  code?: string;
  details?: Record<string, unknown>;
}

export const handleApiError = (error: unknown): ApiError => {
  if (error instanceof AxiosError) {
    const message = error.response?.data?.message || error.response?.data?.error || error.message || 'An error occurred';
    const code = error.response?.data?.code || error.code;
    const details = error.response?.data?.details;

    // Show toast notification
    toast.error(message);

    return {
      message,
      code,
      details,
    };
  }

  if (error instanceof Error) {
    toast.error(error.message);
    return {
      message: error.message,
    };
  }

  const fallbackMessage = 'An unexpected error occurred';
  toast.error(fallbackMessage);

  return {
    message: fallbackMessage,
  };
};
